module.exports = __webpack_public_path__ + "static/media/logo.953dbffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 75
// module chunks = 0